import { UserPermission } from '@/modules/permission/enum';
export const incidentRoutes = [
    {
        path: '',
        name: 'Incidents',
        exact: true,
        component: () => import('../views/IncidentList.vue'),
        meta: {
            breadcrumb: [{ label: 'All Incidents' }],
            permissions: [UserPermission.READ_DEBRIEF],
        },
    },
    {
        path: 'createUpdate',
        name: 'IncidentCreateUpdate',
        exact: true,
        props: route => ({ incidentId: route.query.incidentId }),
        component: () => import('../views/IncidentCreateUpdate.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'All Debriefs', routerLink: { name: 'Debriefs' } }, label: 'Debrief Form' }],
            permissions: [UserPermission.WRITE_DEBRIEF],
        },
    },
];
